import React from 'react';
import { useRecordContext } from 'react-admin';

const ImgField = (props) => {
  // In react-admin v5, use useRecordContext to get the record
  const record = useRecordContext(props);

  // If no record, return null
  if (!record) {
    return null;
  }

  // Use the src property if available (works for both new uploads and formatted existing images)
  if (record.src) {
    return (
      <img width={props.width || '100px'} src={record.src} alt="" style={{ padding: '5px' }} />
    );
  }

  // Fallback: construct URL from picture filename (for existing images without src)
  if (record.picture) {
    return (
      <img
        style={{ padding: '5px' }}
        src={`${process.env.REACT_APP_IMAGES_FILE_HOST}/fit-in/${props.width || 50}x${
          props.height || 50
        }/${record.picture}`}
        alt=""
      />
    );
  }

  return null;
};

export default ImgField;
